// extracted by mini-css-extract-plugin
export default {"h3":"fonts_h3__DMbfu","h4":"fonts_h4__ie2G-","h5":"fonts_h5__9iDq8","pGrey":"fonts_pGrey__VeBxb","footerText":"fonts_footerText__HLaIf"};